export const VOD = 'VOD';
export const TV = 'TV';
export const M_CHANNEL = 'MCHANNEL';
export const CATCHUP = 'CATCHUP';
export const TRAILER = 'TRAILER';
export const LIVE = 'LIVE';
export const OTHER = 'OTHER';

/**
 * @typedef {"VOD"|"TV"|"M_CHANNEL"|"CATCHUP"|"TRAILER"|"LIVE"|"OTHER"} ET.ContentType
 */

/**
 * Map actual content type to more general according to rules:
 *
 * - TV: tv, tv_dvr, tv_dvr_vod, tv_linear, tv_linear_vod
 * - VOD: vod
 * - MCHANNEL: m_ch, m_ch_vod
 * - CATCHUP: tv_dvr_catchup
 * - TRAILER: trailer
 * - LIVE: live
 *
 * Based on the similar logic from mggp-plugin-met
 * @type {Map<string, ContentType>}
 */
const map = new Map([
  ['tv', TV],
  ['tv_dvr', TV],
  ['tv_dvr_vod', TV],
  ['tv_linear', TV],
  ['tv_linear_vod', TV],
  ['vod', VOD],
  ['m_ch', M_CHANNEL],
  ['m_ch_vod', M_CHANNEL],
  ['tv_dvr_catchup', CATCHUP],
  ['trailer', TRAILER],
  ['live', LIVE],
]);

/**
 * Generalize content type
 * @param {string} contentType
 * @return {ContentType}
 */
export function generalizeContentType(contentType){
    return map.get(contentType) || OTHER;
}
